// Telegram Mini App: тема, кнопка «Назад», initData. SDK — web/public/vendor (telegram.org из РФ не открывается).
type BackButton = { show(): void; hide(): void; onClick(f: () => void): void; offClick(f: () => void): void };
type WebApp = {
  initData: string; initDataUnsafe: { start_param?: string; user?: { id: number } };
  colorScheme: 'light' | 'dark'; themeParams: Record<string, string>; platform: string;
  ready(): void; expand(): void; openTelegramLink(url: string): void; openLink(url: string): void;
  BackButton: BackButton; onEvent(e: string, f: () => void): void;
};

const wa = (): WebApp | undefined => (window as any).Telegram?.WebApp;
export const inTelegram = () => !!wa()?.initData;
export const initData = () => wa()?.initData ?? '';
export const tgStartParam = () => wa()?.initDataUnsafe?.start_param ?? null;

export function setupTelegram() {
  const w = wa();
  if (!w || !w.initData) return;
  w.ready();
  w.expand();
  const apply = () => {
    const r = document.documentElement;
    r.dataset.theme = w.colorScheme;
    const p = w.themeParams;
    if (p.bg_color) r.style.setProperty('--bg', p.bg_color);
    if (p.text_color) r.style.setProperty('--text', p.text_color);
    if (p.hint_color) r.style.setProperty('--muted', p.hint_color);
    if (p.secondary_bg_color) r.style.setProperty('--card', p.secondary_bg_color);
  };
  apply();
  w.onEvent('themeChanged', apply);
}

let backHandler: (() => void) | null = null;
export function telegramBack(onBack: (() => void) | null) {
  const b = wa()?.BackButton;
  if (!b || !inTelegram()) return;
  if (backHandler) b.offClick(backHandler);
  backHandler = onBack;
  if (onBack) { b.onClick(onBack); b.show(); } else b.hide();
}

// ссылка на бота: в Telegram — внутри Telegram, на сайте — новая вкладка
export function openTelegramLink(url: string) {
  const w = wa();
  if (w && inTelegram()) w.openTelegramLink(url);
  else window.open(url, '_blank', 'noopener');
}
